import { add, endOfMonth, format, startOfMonth, sub } from "date-fns";

import { QuickDateOption } from "../types";

export const getQuickDateResponse = (quickDateOption: QuickDateOption) => {
  switch (quickDateOption) {
    case "Next30":
      return getNext30DaysResponse();
    case "Previous30":
      return getPrevious30DaysResponse();
    case "FullYear":
      return getFullYearResponse();
    case "SecondNextMonth":
      return getSecondNextMonthResponse();
    case "NextMonth":
      return getNextMonthResponse();
    default:
      return getNext30DaysResponse();
  }
};

const getNextMonthResponse = () => {
  const now = new Date();
  const startDateOfMonth = startOfMonth(add(now, { months: 1 }));
  const startDate = format(startDateOfMonth, "yyyy-MM-dd");
  const endDate = format(endOfMonth(startDateOfMonth), "yyyy-MM-dd");
  return { startDate, endDate };
};

const getNext30DaysResponse = () => {
  const now = new Date();
  const startDate = format(now, "yyyy-MM-dd");
  const endDate = format(add(now, { days: 30 }), "yyyy-MM-dd");
  return { startDate, endDate };
};

const getPrevious30DaysResponse = () => {
  const now = new Date();
  const startDate = format(sub(now, { days: 31 }), "yyyy-MM-dd");
  const endDate = format(sub(now, { days: 1 }), "yyyy-MM-dd");
  return { startDate, endDate };
};

const getSecondNextMonthResponse = () => {
  const now = new Date();
  const startDateOfMonth = startOfMonth(add(now, { months: 2 }));
  const startDate = format(startDateOfMonth, "yyyy-MM-dd");
  const endDate = format(endOfMonth(startDateOfMonth), "yyyy-MM-dd");
  return { startDate, endDate };
};

const getFullYearResponse = () => {
  const now = new Date();
  const startDate = format(now, "yyyy-MM-dd");
  const endDate = format(add(now, { months: 12 }), "yyyy-MM-dd");
  return { startDate, endDate };
};
